export default {
  locale: 'no',
  Search: {
    Search: 'Søk',
    Loading: 'Laster',
    Clear: 'Nullstill søk'
  },
  ArticleList: {
    ReadMore: 'Les mer',
    Loading: 'Laster',
    NoResults: 'Ingen resultater funnet.',
    NoResultsTryChange: 'Forsøk å panorere i kartet eller velg andre kilder.'
  },
  ArticleWindow: {
    locale: 'nb-NO',
    OpenExternal: 'Åpne kildeartikkel i nytt vindu',
    Close: 'Lukk',
    Loading: 'Laster artikkel',
    LoadError: 'Kunne ikke laste artikkel.'
  },
  ArticleComments: {
    locale: 'nb-NO',
    Comment: 'Skriv en kommentar',
    DisplayName: 'Visningsnavn',
    Email: 'E-post (ikke vist)',
    Submit: 'Publiser',
    CouldNotPostComment: 'En feil oppstod.',
    Publishing: 'Publiserer...',
    Hide: 'Skjul'
  },
  Comments: {
    locale: 'nb-NO',
    NoTitle: '(Ingen tittel)',
    Previous: 'Forrige',
    Next: 'Neste',
    Page: 'Side',
    Of: 'av',
    Flag: 'Rapporter som upassende',
    Flagged: 'Rapportert'
  },
  SearchSource: {
    locale: 'nb-NO',
    showAllResults: 'Vis alle treff',
    goBack: 'Tilbake'
  }
};